import { observer } from 'mobx-react';
import React, { FC, useCallback, useEffect, useRef } from 'react';
import { TableOutlined } from '@ant-design/icons';

import { ModalPosition, openModal } from 'controls/react/ant/antModal';
import { AntInput } from 'controls/react/ant/antInput';
import { AntButton } from 'controls/react/ant/antButton';
import {
	DatasourceSelectionConfig,
	SelectionMode,
} from 'controls/designer/features/widgets/datasources/datasourceSelectionConfig';

import { DataSourceColumnSelectorProps } from './types';

export const DataSourceColumnSelector: FC<DataSourceColumnSelectorProps> = observer(
	({ manager, accountId, dataSourceId, requestId, fieldType, value, onChange, disabled }) => {
		const closeEditor = useRef<() => void | undefined>();

		useEffect(() => {
			return () => closeEditor.current?.();
		}, []);

		const onEdit = useCallback(() => {
			if (disabled) return;

			const modalResult = openModal(
				{
					title: '',
					width: 700,
					height: 500,
					resizable: true,
					footer: null,
					mask: false,
					positionType: ModalPosition.Mouse,
				},
				<DatasourceSelectionConfig
					accountId={accountId}
					dataSourceId={dataSourceId}
					requestId={requestId}
					selectionMode={SelectionMode.Columns}
					fieldType={fieldType}
					value={value ? [value] : []}
					onChange={(values) => {
						onChange(values[values.length - 1]);
						modalResult.close();
					}}
					onCancel={() => modalResult.close()}
				/>,
			);
			closeEditor.current = modalResult.close;
		}, [accountId, dataSourceId, requestId, fieldType, value, onChange, disabled]);

		const label = value ? (manager.rulesConfiguration.data?.[value]?.label ?? value) : undefined;

		return (
			<>
				<AntInput
					style={{ cursor: disabled ? undefined : 'pointer' }}
					readOnly={true}
					disabled={disabled}
					value={label}
					onClick={onEdit}
				/>
				<AntButton type={'text'} onClick={onEdit} disabled={disabled} icon={<TableOutlined />} />
			</>
		);
	},
);
